import * as React from "react";
const SvgDangerLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m12.872 2.51 9 16A1 1 0 0 1 21 20H3a1 1 0 0 1-.871-1.49l9-16a1 1 0 0 1 1.743 0M12 5.039 4.71 18h14.58zM12 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-7a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1", clipRule: "evenodd" }));
export default SvgDangerLine;
